module.exports = __webpack_public_path__ + "img/logo_bitda_footer.e79fc9e4.png";